export function getMaps() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/get-list';
    return fetch(requestUrl, requestOptions)
}

export function getMap(id: number) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/get/' + id;
    return fetch(requestUrl, requestOptions)
}

export function getMapByHashcode(h: string) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/get-by-hashcode/' + h;
    return fetch(requestUrl, requestOptions)
}

export function newMap(map_obj: any) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(map_obj)
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/new';
    return fetch(requestUrl, requestOptions)
}

export function updateMap(map_obj: any) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(map_obj)
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/update';
    return fetch(requestUrl, requestOptions)
}

export function newMapGroup(map_obj: any) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(map_obj)
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/group/new';
    return fetch(requestUrl, requestOptions)
}

export function updateMapGroup(map_obj: any) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(map_obj)
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/group/update';
    return fetch(requestUrl, requestOptions)
}

export function deleteMap(id: number) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
            id: id
        })
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/delete';
    return fetch(requestUrl, requestOptions)
}

export function deleteMapGroup(id: number) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'//,
            //'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
            id: id
        })
    };
    let requestUrl = 'https://www.penedesturisme.cat/rest/penedes/api/maps/group/delete';
    return fetch(requestUrl, requestOptions)
}